import React from "react";
import OrderHistorySkeleton from "../OrderHistorySkeleton";

const ProfileOrderHistorySkeleton: React.FC = () => {
  return (
    <div className="relative pt-10 pb-20 px-14 max-xl:px-10 max-md:p-0">
      <div className="relative">
        <h2 className="text-primary text-2xl mb-6 max-md:mb-4 max-sm:mb-2 max-md:text-xl">
          Order history
        </h2>

        <div className="relative overflow-x-auto max-h-[600px] max-md:max-h-full overflow-auto pe-3">
          <OrderHistorySkeleton />
        </div>
      </div>
    </div>
  );
};

export default ProfileOrderHistorySkeleton;
